import { http, HttpResponse } from 'msw';

import { env } from '@/config/env';
import { axios } from '@/lib/axios';
import { networkDelay, requireAuth } from '@/test/mocks/utils';

import { GetReferralDataResponse } from '../types';

export const getReferralData = (): Promise<GetReferralDataResponse.Root> => {
  return axios.get(`/user/referrals/v1/get-referral-code`);
};

export const getReferralDataMockHandler = http.get(
  `${env.API_URL}/user/referrals/v1/get-referral-code`,
  async ({ cookies }): Promise<HttpResponse<GetReferralDataResponse.Root>> => {
    await networkDelay();
    const { error } = requireAuth(cookies);
    if (error) {
      return HttpResponse.json(
        {
          message: 'Failed to get referral data',
          referral_code: '',
        },
        { status: 401 }
      );
    }

    return HttpResponse.json({
      message: 'Referral code fetched successfully.',
      referral_code: '9frGmrz6',
    });
  }
);
